module.exports = __webpack_public_path__ + "static/media/something-went-wrong.26d3ec77.svg";